import { render, staticRenderFns } from "./DashBoardTopDemo.vue?vue&type=template&id=3b457f03&"
import script from "./DashBoardTopDemo.vue?vue&type=script&lang=js&"
export * from "./DashBoardTopDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports